import { render, staticRenderFns } from "./expandRewards.vue?vue&type=template&id=77b3d676"
import script from "./expandRewards.vue?vue&type=script&lang=js"
export * from "./expandRewards.vue?vue&type=script&lang=js"
import style0 from "./expandRewards.vue?vue&type=style&index=0&id=77b3d676&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports